module.exports = __webpack_public_path__ + "assets/img/0b1c72967d10b3407ff7bdc9bac2707e.svg";